import { intl } from 'i18n';
import React from 'react';
import { MessageDescriptor } from 'react-intl';
import Navbar from './CareerNavbar/CareerNavbar';

export interface GlobalHeaderProps {
  heading: MessageDescriptor;
}

export const GlobalHeader: React.FC<GlobalHeaderProps> = ({ heading }) => {
  return (
    <>
      <Navbar />
      <div className='wave-background'>
        <div className='content-container'>{intl.formatMessage(heading)}</div>
      </div>
    </>
  );
};
